export const API_APARTMENT_AUTOCOMPLETE = '/api/apartment/autocomplete'
export const API_APARTMENT_INIT = '/api/travel/init-apartment'